/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResearchBarRouteImport } from './routes/research-bar'
import { Route as RechercheRouteImport } from './routes/recherche'
import { Route as BookingRouteImport } from './routes/_booking'
import { Route as Blue_headerRouteImport } from './routes/_blue_header'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ResearchBarEmbedRouteImport } from './routes/research-bar.embed'
import { Route as RechercheIntegrationRouteImport } from './routes/recherche.integration'
import { Route as PaymentConfirmationStatusRouteImport } from './routes/payment-confirmation.$status'
import { Route as ConfirmationPaiementStatusRouteImport } from './routes/confirmation-paiement.$status'
import { Route as BookingPaiementRouteImport } from './routes/_booking/paiement'
import { Route as BookingInformationsRouteImport } from './routes/_booking/informations'
import { Route as BookingCheckoutRouteImport } from './routes/_booking/checkout'
import { Route as BookingAssurancesRouteImport } from './routes/_booking/assurances'
import { Route as Blue_headerEstimateSentRouteImport } from './routes/_blue_header/estimate-sent'
import { Route as Blue_headerEstimateRouteImport } from './routes/_blue_header/estimate'
import { Route as Blue_headerDevisEnvoyeRouteImport } from './routes/_blue_header/devis-envoye'
import { Route as Blue_headerDevisRouteImport } from './routes/_blue_header/devis'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthReinitialiserMotDePasseRouteImport } from './routes/_auth/reinitialiser-mot-de-passe'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthMotDePasseOublieRouteImport } from './routes/_auth/mot-de-passe-oublie'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthInscriptionRouteImport } from './routes/_auth/inscription'
import { Route as AuthForgottenPasswordRouteImport } from './routes/_auth/forgotten-password'
import { Route as AuthConnexionRouteImport } from './routes/_auth/connexion'
import { Route as AuthActiverMonCompteRouteImport } from './routes/_auth/activer-mon-compte'
import { Route as Blue_headerPayerAcompteIndexRouteImport } from './routes/_blue_header/payer-acompte/index'
import { Route as AuthenticatedLayoutIndexRouteImport } from './routes/_authenticated/_layout/index'
import { Route as BookingVolsResultatsRouteImport } from './routes/_booking/vols.resultats'
import { Route as BookingVolsMultiResultatsRouteImport } from './routes/_booking/vols-multi.resultats'
import { Route as BookingFlightsmanyqueryResultsRouteImport } from './routes/_booking/flightsmanyquery.results'
import { Route as BookingFlightsResultsRouteImport } from './routes/_booking/flights.results'
import { Route as Blue_headerReservationEstimateResponseIdRouteImport } from './routes/_blue_header/reservation.$estimateResponseId'
import { Route as Blue_headerReservationConfirmationReservationIdRouteImport } from './routes/_blue_header/reservation-confirmation.$reservationId'
import { Route as Blue_headerPayerAcompteLegacyRouteImport } from './routes/_blue_header/payer-acompte/legacy'
import { Route as Blue_headerPayerAcompteAncienRouteImport } from './routes/_blue_header/payer-acompte/ancien'
import { Route as Blue_headerDevisEstimateResponseIdRouteImport } from './routes/_blue_header/devis_.$estimateResponseId'
import { Route as Blue_headerDemandeEstimateIdRouteImport } from './routes/_blue_header/demande.$estimateId'
import { Route as Blue_headerConfirmationReservationReservationIdRouteImport } from './routes/_blue_header/confirmation-reservation.$reservationId'
import { Route as AuthenticatedLayoutPersonalInformationsRouteImport } from './routes/_authenticated/_layout/personal-informations'
import { Route as AuthenticatedLayoutMonProfilRouteImport } from './routes/_authenticated/_layout/mon-profil'
import { Route as AuthenticatedLayoutMesDevisRouteImport } from './routes/_authenticated/_layout/mes-devis'
import { Route as AuthenticatedLayoutInformationsPersonnellesRouteImport } from './routes/_authenticated/_layout/informations-personnelles'
import { Route as Blue_headerDevisEstimateResponseIdReserverRouteImport } from './routes/_blue_header/devis_.$estimateResponseId_.reserver'
import { Route as AuthenticatedLayoutMesReservationsBookingRefRouteImport } from './routes/_authenticated/_layout/mes-reservations.$bookingRef'
import { Route as AuthenticatedLayoutMesDevisNouvelleDemandeRouteImport } from './routes/_authenticated/_layout/mes-devis_.nouvelle-demande'
import { Route as AuthenticatedLayoutBookingBookingRefRouteImport } from './routes/_authenticated/_layout/booking.$bookingRef'
import { Route as AuthenticatedLayoutMesDevisEstimateResponseIdReserverRouteImport } from './routes/_authenticated/_layout/mes-devis_.$estimateResponseId.reserver'

const ResearchBarRoute = ResearchBarRouteImport.update({
  id: '/research-bar',
  path: '/research-bar',
  getParentRoute: () => rootRouteImport,
} as any)
const RechercheRoute = RechercheRouteImport.update({
  id: '/recherche',
  path: '/recherche',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingRoute = BookingRouteImport.update({
  id: '/_booking',
  getParentRoute: () => rootRouteImport,
} as any)
const Blue_headerRoute = Blue_headerRouteImport.update({
  id: '/_blue_header',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ResearchBarEmbedRoute = ResearchBarEmbedRouteImport.update({
  id: '/embed',
  path: '/embed',
  getParentRoute: () => ResearchBarRoute,
} as any)
const RechercheIntegrationRoute = RechercheIntegrationRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => RechercheRoute,
} as any)
const PaymentConfirmationStatusRoute =
  PaymentConfirmationStatusRouteImport.update({
    id: '/payment-confirmation/$status',
    path: '/payment-confirmation/$status',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfirmationPaiementStatusRoute =
  ConfirmationPaiementStatusRouteImport.update({
    id: '/confirmation-paiement/$status',
    path: '/confirmation-paiement/$status',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingPaiementRoute = BookingPaiementRouteImport.update({
  id: '/paiement',
  path: '/paiement',
  getParentRoute: () => BookingRoute,
} as any)
const BookingInformationsRoute = BookingInformationsRouteImport.update({
  id: '/informations',
  path: '/informations',
  getParentRoute: () => BookingRoute,
} as any)
const BookingCheckoutRoute = BookingCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => BookingRoute,
} as any)
const BookingAssurancesRoute = BookingAssurancesRouteImport.update({
  id: '/assurances',
  path: '/assurances',
  getParentRoute: () => BookingRoute,
} as any)
const Blue_headerEstimateSentRoute = Blue_headerEstimateSentRouteImport.update({
  id: '/estimate-sent',
  path: '/estimate-sent',
  getParentRoute: () => Blue_headerRoute,
} as any)
const Blue_headerEstimateRoute = Blue_headerEstimateRouteImport.update({
  id: '/estimate',
  path: '/estimate',
  getParentRoute: () => Blue_headerRoute,
} as any)
const Blue_headerDevisEnvoyeRoute = Blue_headerDevisEnvoyeRouteImport.update({
  id: '/devis-envoye',
  path: '/devis-envoye',
  getParentRoute: () => Blue_headerRoute,
} as any)
const Blue_headerDevisRoute = Blue_headerDevisRouteImport.update({
  id: '/devis',
  path: '/devis',
  getParentRoute: () => Blue_headerRoute,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReinitialiserMotDePasseRoute =
  AuthReinitialiserMotDePasseRouteImport.update({
    id: '/reinitialiser-mot-de-passe',
    path: '/reinitialiser-mot-de-passe',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMotDePasseOublieRoute = AuthMotDePasseOublieRouteImport.update({
  id: '/mot-de-passe-oublie',
  path: '/mot-de-passe-oublie',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInscriptionRoute = AuthInscriptionRouteImport.update({
  id: '/inscription',
  path: '/inscription',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgottenPasswordRoute = AuthForgottenPasswordRouteImport.update({
  id: '/forgotten-password',
  path: '/forgotten-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConnexionRoute = AuthConnexionRouteImport.update({
  id: '/connexion',
  path: '/connexion',
  getParentRoute: () => AuthRoute,
} as any)
const AuthActiverMonCompteRoute = AuthActiverMonCompteRouteImport.update({
  id: '/activer-mon-compte',
  path: '/activer-mon-compte',
  getParentRoute: () => AuthRoute,
} as any)
const Blue_headerPayerAcompteIndexRoute =
  Blue_headerPayerAcompteIndexRouteImport.update({
    id: '/payer-acompte/',
    path: '/payer-acompte/',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const AuthenticatedLayoutIndexRoute =
  AuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const BookingVolsResultatsRoute = BookingVolsResultatsRouteImport.update({
  id: '/vols/resultats',
  path: '/vols/resultats',
  getParentRoute: () => BookingRoute,
} as any)
const BookingVolsMultiResultatsRoute =
  BookingVolsMultiResultatsRouteImport.update({
    id: '/vols-multi/resultats',
    path: '/vols-multi/resultats',
    getParentRoute: () => BookingRoute,
  } as any)
const BookingFlightsmanyqueryResultsRoute =
  BookingFlightsmanyqueryResultsRouteImport.update({
    id: '/flightsmanyquery/results',
    path: '/flightsmanyquery/results',
    getParentRoute: () => BookingRoute,
  } as any)
const BookingFlightsResultsRoute = BookingFlightsResultsRouteImport.update({
  id: '/flights/results',
  path: '/flights/results',
  getParentRoute: () => BookingRoute,
} as any)
const Blue_headerReservationEstimateResponseIdRoute =
  Blue_headerReservationEstimateResponseIdRouteImport.update({
    id: '/reservation/$estimateResponseId',
    path: '/reservation/$estimateResponseId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerReservationConfirmationReservationIdRoute =
  Blue_headerReservationConfirmationReservationIdRouteImport.update({
    id: '/reservation-confirmation/$reservationId',
    path: '/reservation-confirmation/$reservationId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerPayerAcompteLegacyRoute =
  Blue_headerPayerAcompteLegacyRouteImport.update({
    id: '/payer-acompte/legacy',
    path: '/payer-acompte/legacy',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerPayerAcompteAncienRoute =
  Blue_headerPayerAcompteAncienRouteImport.update({
    id: '/payer-acompte/ancien',
    path: '/payer-acompte/ancien',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerDevisEstimateResponseIdRoute =
  Blue_headerDevisEstimateResponseIdRouteImport.update({
    id: '/devis_/$estimateResponseId',
    path: '/devis/$estimateResponseId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerDemandeEstimateIdRoute =
  Blue_headerDemandeEstimateIdRouteImport.update({
    id: '/demande/$estimateId',
    path: '/demande/$estimateId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerConfirmationReservationReservationIdRoute =
  Blue_headerConfirmationReservationReservationIdRouteImport.update({
    id: '/confirmation-reservation/$reservationId',
    path: '/confirmation-reservation/$reservationId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const AuthenticatedLayoutPersonalInformationsRoute =
  AuthenticatedLayoutPersonalInformationsRouteImport.update({
    id: '/personal-informations',
    path: '/personal-informations',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMonProfilRoute =
  AuthenticatedLayoutMonProfilRouteImport.update({
    id: '/mon-profil',
    path: '/mon-profil',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMesDevisRoute =
  AuthenticatedLayoutMesDevisRouteImport.update({
    id: '/mes-devis',
    path: '/mes-devis',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutInformationsPersonnellesRoute =
  AuthenticatedLayoutInformationsPersonnellesRouteImport.update({
    id: '/informations-personnelles',
    path: '/informations-personnelles',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const Blue_headerDevisEstimateResponseIdReserverRoute =
  Blue_headerDevisEstimateResponseIdReserverRouteImport.update({
    id: '/devis_/$estimateResponseId_/reserver',
    path: '/devis/$estimateResponseId/reserver',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const AuthenticatedLayoutMesReservationsBookingRefRoute =
  AuthenticatedLayoutMesReservationsBookingRefRouteImport.update({
    id: '/mes-reservations/$bookingRef',
    path: '/mes-reservations/$bookingRef',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMesDevisNouvelleDemandeRoute =
  AuthenticatedLayoutMesDevisNouvelleDemandeRouteImport.update({
    id: '/mes-devis_/nouvelle-demande',
    path: '/mes-devis/nouvelle-demande',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutBookingBookingRefRoute =
  AuthenticatedLayoutBookingBookingRefRouteImport.update({
    id: '/booking/$bookingRef',
    path: '/booking/$bookingRef',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute =
  AuthenticatedLayoutMesDevisEstimateResponseIdReserverRouteImport.update({
    id: '/mes-devis_/$estimateResponseId/reserver',
    path: '/mes-devis/$estimateResponseId/reserver',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/recherche': typeof RechercheRouteWithChildren
  '/research-bar': typeof ResearchBarRouteWithChildren
  '/activer-mon-compte': typeof AuthActiverMonCompteRoute
  '/connexion': typeof AuthConnexionRoute
  '/forgotten-password': typeof AuthForgottenPasswordRoute
  '/inscription': typeof AuthInscriptionRoute
  '/login': typeof AuthLoginRoute
  '/mot-de-passe-oublie': typeof AuthMotDePasseOublieRoute
  '/register': typeof AuthRegisterRoute
  '/reinitialiser-mot-de-passe': typeof AuthReinitialiserMotDePasseRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/devis': typeof Blue_headerDevisRoute
  '/devis-envoye': typeof Blue_headerDevisEnvoyeRoute
  '/estimate': typeof Blue_headerEstimateRoute
  '/estimate-sent': typeof Blue_headerEstimateSentRoute
  '/assurances': typeof BookingAssurancesRoute
  '/checkout': typeof BookingCheckoutRoute
  '/informations': typeof BookingInformationsRoute
  '/paiement': typeof BookingPaiementRoute
  '/confirmation-paiement/$status': typeof ConfirmationPaiementStatusRoute
  '/payment-confirmation/$status': typeof PaymentConfirmationStatusRoute
  '/recherche/integration': typeof RechercheIntegrationRoute
  '/research-bar/embed': typeof ResearchBarEmbedRoute
  '/informations-personnelles': typeof AuthenticatedLayoutInformationsPersonnellesRoute
  '/mes-devis': typeof AuthenticatedLayoutMesDevisRoute
  '/mon-profil': typeof AuthenticatedLayoutMonProfilRoute
  '/personal-informations': typeof AuthenticatedLayoutPersonalInformationsRoute
  '/confirmation-reservation/$reservationId': typeof Blue_headerConfirmationReservationReservationIdRoute
  '/demande/$estimateId': typeof Blue_headerDemandeEstimateIdRoute
  '/devis/$estimateResponseId': typeof Blue_headerDevisEstimateResponseIdRoute
  '/payer-acompte/ancien': typeof Blue_headerPayerAcompteAncienRoute
  '/payer-acompte/legacy': typeof Blue_headerPayerAcompteLegacyRoute
  '/reservation-confirmation/$reservationId': typeof Blue_headerReservationConfirmationReservationIdRoute
  '/reservation/$estimateResponseId': typeof Blue_headerReservationEstimateResponseIdRoute
  '/flights/results': typeof BookingFlightsResultsRoute
  '/flightsmanyquery/results': typeof BookingFlightsmanyqueryResultsRoute
  '/vols-multi/resultats': typeof BookingVolsMultiResultatsRoute
  '/vols/resultats': typeof BookingVolsResultatsRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/payer-acompte': typeof Blue_headerPayerAcompteIndexRoute
  '/booking/$bookingRef': typeof AuthenticatedLayoutBookingBookingRefRoute
  '/mes-devis/nouvelle-demande': typeof AuthenticatedLayoutMesDevisNouvelleDemandeRoute
  '/mes-reservations/$bookingRef': typeof AuthenticatedLayoutMesReservationsBookingRefRoute
  '/devis/$estimateResponseId/reserver': typeof Blue_headerDevisEstimateResponseIdReserverRoute
  '/mes-devis/$estimateResponseId/reserver': typeof AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute
}
export interface FileRoutesByTo {
  '/recherche': typeof RechercheRouteWithChildren
  '/research-bar': typeof ResearchBarRouteWithChildren
  '/activer-mon-compte': typeof AuthActiverMonCompteRoute
  '/connexion': typeof AuthConnexionRoute
  '/forgotten-password': typeof AuthForgottenPasswordRoute
  '/inscription': typeof AuthInscriptionRoute
  '/login': typeof AuthLoginRoute
  '/mot-de-passe-oublie': typeof AuthMotDePasseOublieRoute
  '/register': typeof AuthRegisterRoute
  '/reinitialiser-mot-de-passe': typeof AuthReinitialiserMotDePasseRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/devis': typeof Blue_headerDevisRoute
  '/devis-envoye': typeof Blue_headerDevisEnvoyeRoute
  '/estimate': typeof Blue_headerEstimateRoute
  '/estimate-sent': typeof Blue_headerEstimateSentRoute
  '/assurances': typeof BookingAssurancesRoute
  '/checkout': typeof BookingCheckoutRoute
  '/informations': typeof BookingInformationsRoute
  '/paiement': typeof BookingPaiementRoute
  '/confirmation-paiement/$status': typeof ConfirmationPaiementStatusRoute
  '/payment-confirmation/$status': typeof PaymentConfirmationStatusRoute
  '/recherche/integration': typeof RechercheIntegrationRoute
  '/research-bar/embed': typeof ResearchBarEmbedRoute
  '/informations-personnelles': typeof AuthenticatedLayoutInformationsPersonnellesRoute
  '/mes-devis': typeof AuthenticatedLayoutMesDevisRoute
  '/mon-profil': typeof AuthenticatedLayoutMonProfilRoute
  '/personal-informations': typeof AuthenticatedLayoutPersonalInformationsRoute
  '/confirmation-reservation/$reservationId': typeof Blue_headerConfirmationReservationReservationIdRoute
  '/demande/$estimateId': typeof Blue_headerDemandeEstimateIdRoute
  '/devis/$estimateResponseId': typeof Blue_headerDevisEstimateResponseIdRoute
  '/payer-acompte/ancien': typeof Blue_headerPayerAcompteAncienRoute
  '/payer-acompte/legacy': typeof Blue_headerPayerAcompteLegacyRoute
  '/reservation-confirmation/$reservationId': typeof Blue_headerReservationConfirmationReservationIdRoute
  '/reservation/$estimateResponseId': typeof Blue_headerReservationEstimateResponseIdRoute
  '/flights/results': typeof BookingFlightsResultsRoute
  '/flightsmanyquery/results': typeof BookingFlightsmanyqueryResultsRoute
  '/vols-multi/resultats': typeof BookingVolsMultiResultatsRoute
  '/vols/resultats': typeof BookingVolsResultatsRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/payer-acompte': typeof Blue_headerPayerAcompteIndexRoute
  '/booking/$bookingRef': typeof AuthenticatedLayoutBookingBookingRefRoute
  '/mes-devis/nouvelle-demande': typeof AuthenticatedLayoutMesDevisNouvelleDemandeRoute
  '/mes-reservations/$bookingRef': typeof AuthenticatedLayoutMesReservationsBookingRefRoute
  '/devis/$estimateResponseId/reserver': typeof Blue_headerDevisEstimateResponseIdReserverRoute
  '/mes-devis/$estimateResponseId/reserver': typeof AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_blue_header': typeof Blue_headerRouteWithChildren
  '/_booking': typeof BookingRouteWithChildren
  '/recherche': typeof RechercheRouteWithChildren
  '/research-bar': typeof ResearchBarRouteWithChildren
  '/_auth/activer-mon-compte': typeof AuthActiverMonCompteRoute
  '/_auth/connexion': typeof AuthConnexionRoute
  '/_auth/forgotten-password': typeof AuthForgottenPasswordRoute
  '/_auth/inscription': typeof AuthInscriptionRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/mot-de-passe-oublie': typeof AuthMotDePasseOublieRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reinitialiser-mot-de-passe': typeof AuthReinitialiserMotDePasseRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteWithChildren
  '/_blue_header/devis': typeof Blue_headerDevisRoute
  '/_blue_header/devis-envoye': typeof Blue_headerDevisEnvoyeRoute
  '/_blue_header/estimate': typeof Blue_headerEstimateRoute
  '/_blue_header/estimate-sent': typeof Blue_headerEstimateSentRoute
  '/_booking/assurances': typeof BookingAssurancesRoute
  '/_booking/checkout': typeof BookingCheckoutRoute
  '/_booking/informations': typeof BookingInformationsRoute
  '/_booking/paiement': typeof BookingPaiementRoute
  '/confirmation-paiement/$status': typeof ConfirmationPaiementStatusRoute
  '/payment-confirmation/$status': typeof PaymentConfirmationStatusRoute
  '/recherche/integration': typeof RechercheIntegrationRoute
  '/research-bar/embed': typeof ResearchBarEmbedRoute
  '/_authenticated/_layout/informations-personnelles': typeof AuthenticatedLayoutInformationsPersonnellesRoute
  '/_authenticated/_layout/mes-devis': typeof AuthenticatedLayoutMesDevisRoute
  '/_authenticated/_layout/mon-profil': typeof AuthenticatedLayoutMonProfilRoute
  '/_authenticated/_layout/personal-informations': typeof AuthenticatedLayoutPersonalInformationsRoute
  '/_blue_header/confirmation-reservation/$reservationId': typeof Blue_headerConfirmationReservationReservationIdRoute
  '/_blue_header/demande/$estimateId': typeof Blue_headerDemandeEstimateIdRoute
  '/_blue_header/devis_/$estimateResponseId': typeof Blue_headerDevisEstimateResponseIdRoute
  '/_blue_header/payer-acompte/ancien': typeof Blue_headerPayerAcompteAncienRoute
  '/_blue_header/payer-acompte/legacy': typeof Blue_headerPayerAcompteLegacyRoute
  '/_blue_header/reservation-confirmation/$reservationId': typeof Blue_headerReservationConfirmationReservationIdRoute
  '/_blue_header/reservation/$estimateResponseId': typeof Blue_headerReservationEstimateResponseIdRoute
  '/_booking/flights/results': typeof BookingFlightsResultsRoute
  '/_booking/flightsmanyquery/results': typeof BookingFlightsmanyqueryResultsRoute
  '/_booking/vols-multi/resultats': typeof BookingVolsMultiResultatsRoute
  '/_booking/vols/resultats': typeof BookingVolsResultatsRoute
  '/_authenticated/_layout/': typeof AuthenticatedLayoutIndexRoute
  '/_blue_header/payer-acompte/': typeof Blue_headerPayerAcompteIndexRoute
  '/_authenticated/_layout/booking/$bookingRef': typeof AuthenticatedLayoutBookingBookingRefRoute
  '/_authenticated/_layout/mes-devis_/nouvelle-demande': typeof AuthenticatedLayoutMesDevisNouvelleDemandeRoute
  '/_authenticated/_layout/mes-reservations/$bookingRef': typeof AuthenticatedLayoutMesReservationsBookingRefRoute
  '/_blue_header/devis_/$estimateResponseId_/reserver': typeof Blue_headerDevisEstimateResponseIdReserverRoute
  '/_authenticated/_layout/mes-devis_/$estimateResponseId/reserver': typeof AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/recherche'
    | '/research-bar'
    | '/activer-mon-compte'
    | '/connexion'
    | '/forgotten-password'
    | '/inscription'
    | '/login'
    | '/mot-de-passe-oublie'
    | '/register'
    | '/reinitialiser-mot-de-passe'
    | '/reset-password'
    | '/devis'
    | '/devis-envoye'
    | '/estimate'
    | '/estimate-sent'
    | '/assurances'
    | '/checkout'
    | '/informations'
    | '/paiement'
    | '/confirmation-paiement/$status'
    | '/payment-confirmation/$status'
    | '/recherche/integration'
    | '/research-bar/embed'
    | '/informations-personnelles'
    | '/mes-devis'
    | '/mon-profil'
    | '/personal-informations'
    | '/confirmation-reservation/$reservationId'
    | '/demande/$estimateId'
    | '/devis/$estimateResponseId'
    | '/payer-acompte/ancien'
    | '/payer-acompte/legacy'
    | '/reservation-confirmation/$reservationId'
    | '/reservation/$estimateResponseId'
    | '/flights/results'
    | '/flightsmanyquery/results'
    | '/vols-multi/resultats'
    | '/vols/resultats'
    | '/'
    | '/payer-acompte'
    | '/booking/$bookingRef'
    | '/mes-devis/nouvelle-demande'
    | '/mes-reservations/$bookingRef'
    | '/devis/$estimateResponseId/reserver'
    | '/mes-devis/$estimateResponseId/reserver'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/recherche'
    | '/research-bar'
    | '/activer-mon-compte'
    | '/connexion'
    | '/forgotten-password'
    | '/inscription'
    | '/login'
    | '/mot-de-passe-oublie'
    | '/register'
    | '/reinitialiser-mot-de-passe'
    | '/reset-password'
    | '/devis'
    | '/devis-envoye'
    | '/estimate'
    | '/estimate-sent'
    | '/assurances'
    | '/checkout'
    | '/informations'
    | '/paiement'
    | '/confirmation-paiement/$status'
    | '/payment-confirmation/$status'
    | '/recherche/integration'
    | '/research-bar/embed'
    | '/informations-personnelles'
    | '/mes-devis'
    | '/mon-profil'
    | '/personal-informations'
    | '/confirmation-reservation/$reservationId'
    | '/demande/$estimateId'
    | '/devis/$estimateResponseId'
    | '/payer-acompte/ancien'
    | '/payer-acompte/legacy'
    | '/reservation-confirmation/$reservationId'
    | '/reservation/$estimateResponseId'
    | '/flights/results'
    | '/flightsmanyquery/results'
    | '/vols-multi/resultats'
    | '/vols/resultats'
    | '/'
    | '/payer-acompte'
    | '/booking/$bookingRef'
    | '/mes-devis/nouvelle-demande'
    | '/mes-reservations/$bookingRef'
    | '/devis/$estimateResponseId/reserver'
    | '/mes-devis/$estimateResponseId/reserver'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/_blue_header'
    | '/_booking'
    | '/recherche'
    | '/research-bar'
    | '/_auth/activer-mon-compte'
    | '/_auth/connexion'
    | '/_auth/forgotten-password'
    | '/_auth/inscription'
    | '/_auth/login'
    | '/_auth/mot-de-passe-oublie'
    | '/_auth/register'
    | '/_auth/reinitialiser-mot-de-passe'
    | '/_auth/reset-password'
    | '/_authenticated/_layout'
    | '/_blue_header/devis'
    | '/_blue_header/devis-envoye'
    | '/_blue_header/estimate'
    | '/_blue_header/estimate-sent'
    | '/_booking/assurances'
    | '/_booking/checkout'
    | '/_booking/informations'
    | '/_booking/paiement'
    | '/confirmation-paiement/$status'
    | '/payment-confirmation/$status'
    | '/recherche/integration'
    | '/research-bar/embed'
    | '/_authenticated/_layout/informations-personnelles'
    | '/_authenticated/_layout/mes-devis'
    | '/_authenticated/_layout/mon-profil'
    | '/_authenticated/_layout/personal-informations'
    | '/_blue_header/confirmation-reservation/$reservationId'
    | '/_blue_header/demande/$estimateId'
    | '/_blue_header/devis_/$estimateResponseId'
    | '/_blue_header/payer-acompte/ancien'
    | '/_blue_header/payer-acompte/legacy'
    | '/_blue_header/reservation-confirmation/$reservationId'
    | '/_blue_header/reservation/$estimateResponseId'
    | '/_booking/flights/results'
    | '/_booking/flightsmanyquery/results'
    | '/_booking/vols-multi/resultats'
    | '/_booking/vols/resultats'
    | '/_authenticated/_layout/'
    | '/_blue_header/payer-acompte/'
    | '/_authenticated/_layout/booking/$bookingRef'
    | '/_authenticated/_layout/mes-devis_/nouvelle-demande'
    | '/_authenticated/_layout/mes-reservations/$bookingRef'
    | '/_blue_header/devis_/$estimateResponseId_/reserver'
    | '/_authenticated/_layout/mes-devis_/$estimateResponseId/reserver'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  Blue_headerRoute: typeof Blue_headerRouteWithChildren
  BookingRoute: typeof BookingRouteWithChildren
  RechercheRoute: typeof RechercheRouteWithChildren
  ResearchBarRoute: typeof ResearchBarRouteWithChildren
  ConfirmationPaiementStatusRoute: typeof ConfirmationPaiementStatusRoute
  PaymentConfirmationStatusRoute: typeof PaymentConfirmationStatusRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/research-bar': {
      id: '/research-bar'
      path: '/research-bar'
      fullPath: '/research-bar'
      preLoaderRoute: typeof ResearchBarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recherche': {
      id: '/recherche'
      path: '/recherche'
      fullPath: '/recherche'
      preLoaderRoute: typeof RechercheRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_booking': {
      id: '/_booking'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_blue_header': {
      id: '/_blue_header'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof Blue_headerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/research-bar/embed': {
      id: '/research-bar/embed'
      path: '/embed'
      fullPath: '/research-bar/embed'
      preLoaderRoute: typeof ResearchBarEmbedRouteImport
      parentRoute: typeof ResearchBarRoute
    }
    '/recherche/integration': {
      id: '/recherche/integration'
      path: '/integration'
      fullPath: '/recherche/integration'
      preLoaderRoute: typeof RechercheIntegrationRouteImport
      parentRoute: typeof RechercheRoute
    }
    '/payment-confirmation/$status': {
      id: '/payment-confirmation/$status'
      path: '/payment-confirmation/$status'
      fullPath: '/payment-confirmation/$status'
      preLoaderRoute: typeof PaymentConfirmationStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmation-paiement/$status': {
      id: '/confirmation-paiement/$status'
      path: '/confirmation-paiement/$status'
      fullPath: '/confirmation-paiement/$status'
      preLoaderRoute: typeof ConfirmationPaiementStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_booking/paiement': {
      id: '/_booking/paiement'
      path: '/paiement'
      fullPath: '/paiement'
      preLoaderRoute: typeof BookingPaiementRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/informations': {
      id: '/_booking/informations'
      path: '/informations'
      fullPath: '/informations'
      preLoaderRoute: typeof BookingInformationsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/checkout': {
      id: '/_booking/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof BookingCheckoutRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/assurances': {
      id: '/_booking/assurances'
      path: '/assurances'
      fullPath: '/assurances'
      preLoaderRoute: typeof BookingAssurancesRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_blue_header/estimate-sent': {
      id: '/_blue_header/estimate-sent'
      path: '/estimate-sent'
      fullPath: '/estimate-sent'
      preLoaderRoute: typeof Blue_headerEstimateSentRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/estimate': {
      id: '/_blue_header/estimate'
      path: '/estimate'
      fullPath: '/estimate'
      preLoaderRoute: typeof Blue_headerEstimateRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/devis-envoye': {
      id: '/_blue_header/devis-envoye'
      path: '/devis-envoye'
      fullPath: '/devis-envoye'
      preLoaderRoute: typeof Blue_headerDevisEnvoyeRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/devis': {
      id: '/_blue_header/devis'
      path: '/devis'
      fullPath: '/devis'
      preLoaderRoute: typeof Blue_headerDevisRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reinitialiser-mot-de-passe': {
      id: '/_auth/reinitialiser-mot-de-passe'
      path: '/reinitialiser-mot-de-passe'
      fullPath: '/reinitialiser-mot-de-passe'
      preLoaderRoute: typeof AuthReinitialiserMotDePasseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/mot-de-passe-oublie': {
      id: '/_auth/mot-de-passe-oublie'
      path: '/mot-de-passe-oublie'
      fullPath: '/mot-de-passe-oublie'
      preLoaderRoute: typeof AuthMotDePasseOublieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inscription': {
      id: '/_auth/inscription'
      path: '/inscription'
      fullPath: '/inscription'
      preLoaderRoute: typeof AuthInscriptionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgotten-password': {
      id: '/_auth/forgotten-password'
      path: '/forgotten-password'
      fullPath: '/forgotten-password'
      preLoaderRoute: typeof AuthForgottenPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/connexion': {
      id: '/_auth/connexion'
      path: '/connexion'
      fullPath: '/connexion'
      preLoaderRoute: typeof AuthConnexionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/activer-mon-compte': {
      id: '/_auth/activer-mon-compte'
      path: '/activer-mon-compte'
      fullPath: '/activer-mon-compte'
      preLoaderRoute: typeof AuthActiverMonCompteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_blue_header/payer-acompte/': {
      id: '/_blue_header/payer-acompte/'
      path: '/payer-acompte'
      fullPath: '/payer-acompte'
      preLoaderRoute: typeof Blue_headerPayerAcompteIndexRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout/': {
      id: '/_authenticated/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_booking/vols/resultats': {
      id: '/_booking/vols/resultats'
      path: '/vols/resultats'
      fullPath: '/vols/resultats'
      preLoaderRoute: typeof BookingVolsResultatsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/vols-multi/resultats': {
      id: '/_booking/vols-multi/resultats'
      path: '/vols-multi/resultats'
      fullPath: '/vols-multi/resultats'
      preLoaderRoute: typeof BookingVolsMultiResultatsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/flightsmanyquery/results': {
      id: '/_booking/flightsmanyquery/results'
      path: '/flightsmanyquery/results'
      fullPath: '/flightsmanyquery/results'
      preLoaderRoute: typeof BookingFlightsmanyqueryResultsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/flights/results': {
      id: '/_booking/flights/results'
      path: '/flights/results'
      fullPath: '/flights/results'
      preLoaderRoute: typeof BookingFlightsResultsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_blue_header/reservation/$estimateResponseId': {
      id: '/_blue_header/reservation/$estimateResponseId'
      path: '/reservation/$estimateResponseId'
      fullPath: '/reservation/$estimateResponseId'
      preLoaderRoute: typeof Blue_headerReservationEstimateResponseIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/reservation-confirmation/$reservationId': {
      id: '/_blue_header/reservation-confirmation/$reservationId'
      path: '/reservation-confirmation/$reservationId'
      fullPath: '/reservation-confirmation/$reservationId'
      preLoaderRoute: typeof Blue_headerReservationConfirmationReservationIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/payer-acompte/legacy': {
      id: '/_blue_header/payer-acompte/legacy'
      path: '/payer-acompte/legacy'
      fullPath: '/payer-acompte/legacy'
      preLoaderRoute: typeof Blue_headerPayerAcompteLegacyRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/payer-acompte/ancien': {
      id: '/_blue_header/payer-acompte/ancien'
      path: '/payer-acompte/ancien'
      fullPath: '/payer-acompte/ancien'
      preLoaderRoute: typeof Blue_headerPayerAcompteAncienRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/devis_/$estimateResponseId': {
      id: '/_blue_header/devis_/$estimateResponseId'
      path: '/devis/$estimateResponseId'
      fullPath: '/devis/$estimateResponseId'
      preLoaderRoute: typeof Blue_headerDevisEstimateResponseIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/demande/$estimateId': {
      id: '/_blue_header/demande/$estimateId'
      path: '/demande/$estimateId'
      fullPath: '/demande/$estimateId'
      preLoaderRoute: typeof Blue_headerDemandeEstimateIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/confirmation-reservation/$reservationId': {
      id: '/_blue_header/confirmation-reservation/$reservationId'
      path: '/confirmation-reservation/$reservationId'
      fullPath: '/confirmation-reservation/$reservationId'
      preLoaderRoute: typeof Blue_headerConfirmationReservationReservationIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout/personal-informations': {
      id: '/_authenticated/_layout/personal-informations'
      path: '/personal-informations'
      fullPath: '/personal-informations'
      preLoaderRoute: typeof AuthenticatedLayoutPersonalInformationsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/mon-profil': {
      id: '/_authenticated/_layout/mon-profil'
      path: '/mon-profil'
      fullPath: '/mon-profil'
      preLoaderRoute: typeof AuthenticatedLayoutMonProfilRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/mes-devis': {
      id: '/_authenticated/_layout/mes-devis'
      path: '/mes-devis'
      fullPath: '/mes-devis'
      preLoaderRoute: typeof AuthenticatedLayoutMesDevisRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/informations-personnelles': {
      id: '/_authenticated/_layout/informations-personnelles'
      path: '/informations-personnelles'
      fullPath: '/informations-personnelles'
      preLoaderRoute: typeof AuthenticatedLayoutInformationsPersonnellesRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_blue_header/devis_/$estimateResponseId_/reserver': {
      id: '/_blue_header/devis_/$estimateResponseId_/reserver'
      path: '/devis/$estimateResponseId/reserver'
      fullPath: '/devis/$estimateResponseId/reserver'
      preLoaderRoute: typeof Blue_headerDevisEstimateResponseIdReserverRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout/mes-reservations/$bookingRef': {
      id: '/_authenticated/_layout/mes-reservations/$bookingRef'
      path: '/mes-reservations/$bookingRef'
      fullPath: '/mes-reservations/$bookingRef'
      preLoaderRoute: typeof AuthenticatedLayoutMesReservationsBookingRefRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/mes-devis_/nouvelle-demande': {
      id: '/_authenticated/_layout/mes-devis_/nouvelle-demande'
      path: '/mes-devis/nouvelle-demande'
      fullPath: '/mes-devis/nouvelle-demande'
      preLoaderRoute: typeof AuthenticatedLayoutMesDevisNouvelleDemandeRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/booking/$bookingRef': {
      id: '/_authenticated/_layout/booking/$bookingRef'
      path: '/booking/$bookingRef'
      fullPath: '/booking/$bookingRef'
      preLoaderRoute: typeof AuthenticatedLayoutBookingBookingRefRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/mes-devis_/$estimateResponseId/reserver': {
      id: '/_authenticated/_layout/mes-devis_/$estimateResponseId/reserver'
      path: '/mes-devis/$estimateResponseId/reserver'
      fullPath: '/mes-devis/$estimateResponseId/reserver'
      preLoaderRoute: typeof AuthenticatedLayoutMesDevisEstimateResponseIdReserverRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
  }
}

interface AuthRouteChildren {
  AuthActiverMonCompteRoute: typeof AuthActiverMonCompteRoute
  AuthConnexionRoute: typeof AuthConnexionRoute
  AuthForgottenPasswordRoute: typeof AuthForgottenPasswordRoute
  AuthInscriptionRoute: typeof AuthInscriptionRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMotDePasseOublieRoute: typeof AuthMotDePasseOublieRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthReinitialiserMotDePasseRoute: typeof AuthReinitialiserMotDePasseRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthActiverMonCompteRoute: AuthActiverMonCompteRoute,
  AuthConnexionRoute: AuthConnexionRoute,
  AuthForgottenPasswordRoute: AuthForgottenPasswordRoute,
  AuthInscriptionRoute: AuthInscriptionRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMotDePasseOublieRoute: AuthMotDePasseOublieRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthReinitialiserMotDePasseRoute: AuthReinitialiserMotDePasseRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutInformationsPersonnellesRoute: typeof AuthenticatedLayoutInformationsPersonnellesRoute
  AuthenticatedLayoutMesDevisRoute: typeof AuthenticatedLayoutMesDevisRoute
  AuthenticatedLayoutMonProfilRoute: typeof AuthenticatedLayoutMonProfilRoute
  AuthenticatedLayoutPersonalInformationsRoute: typeof AuthenticatedLayoutPersonalInformationsRoute
  AuthenticatedLayoutIndexRoute: typeof AuthenticatedLayoutIndexRoute
  AuthenticatedLayoutBookingBookingRefRoute: typeof AuthenticatedLayoutBookingBookingRefRoute
  AuthenticatedLayoutMesDevisNouvelleDemandeRoute: typeof AuthenticatedLayoutMesDevisNouvelleDemandeRoute
  AuthenticatedLayoutMesReservationsBookingRefRoute: typeof AuthenticatedLayoutMesReservationsBookingRefRoute
  AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute: typeof AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutInformationsPersonnellesRoute:
    AuthenticatedLayoutInformationsPersonnellesRoute,
  AuthenticatedLayoutMesDevisRoute: AuthenticatedLayoutMesDevisRoute,
  AuthenticatedLayoutMonProfilRoute: AuthenticatedLayoutMonProfilRoute,
  AuthenticatedLayoutPersonalInformationsRoute:
    AuthenticatedLayoutPersonalInformationsRoute,
  AuthenticatedLayoutIndexRoute: AuthenticatedLayoutIndexRoute,
  AuthenticatedLayoutBookingBookingRefRoute:
    AuthenticatedLayoutBookingBookingRefRoute,
  AuthenticatedLayoutMesDevisNouvelleDemandeRoute:
    AuthenticatedLayoutMesDevisNouvelleDemandeRoute,
  AuthenticatedLayoutMesReservationsBookingRefRoute:
    AuthenticatedLayoutMesReservationsBookingRefRoute,
  AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute:
    AuthenticatedLayoutMesDevisEstimateResponseIdReserverRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface Blue_headerRouteChildren {
  Blue_headerDevisRoute: typeof Blue_headerDevisRoute
  Blue_headerDevisEnvoyeRoute: typeof Blue_headerDevisEnvoyeRoute
  Blue_headerEstimateRoute: typeof Blue_headerEstimateRoute
  Blue_headerEstimateSentRoute: typeof Blue_headerEstimateSentRoute
  Blue_headerConfirmationReservationReservationIdRoute: typeof Blue_headerConfirmationReservationReservationIdRoute
  Blue_headerDemandeEstimateIdRoute: typeof Blue_headerDemandeEstimateIdRoute
  Blue_headerDevisEstimateResponseIdRoute: typeof Blue_headerDevisEstimateResponseIdRoute
  Blue_headerPayerAcompteAncienRoute: typeof Blue_headerPayerAcompteAncienRoute
  Blue_headerPayerAcompteLegacyRoute: typeof Blue_headerPayerAcompteLegacyRoute
  Blue_headerReservationConfirmationReservationIdRoute: typeof Blue_headerReservationConfirmationReservationIdRoute
  Blue_headerReservationEstimateResponseIdRoute: typeof Blue_headerReservationEstimateResponseIdRoute
  Blue_headerPayerAcompteIndexRoute: typeof Blue_headerPayerAcompteIndexRoute
  Blue_headerDevisEstimateResponseIdReserverRoute: typeof Blue_headerDevisEstimateResponseIdReserverRoute
}

const Blue_headerRouteChildren: Blue_headerRouteChildren = {
  Blue_headerDevisRoute: Blue_headerDevisRoute,
  Blue_headerDevisEnvoyeRoute: Blue_headerDevisEnvoyeRoute,
  Blue_headerEstimateRoute: Blue_headerEstimateRoute,
  Blue_headerEstimateSentRoute: Blue_headerEstimateSentRoute,
  Blue_headerConfirmationReservationReservationIdRoute:
    Blue_headerConfirmationReservationReservationIdRoute,
  Blue_headerDemandeEstimateIdRoute: Blue_headerDemandeEstimateIdRoute,
  Blue_headerDevisEstimateResponseIdRoute:
    Blue_headerDevisEstimateResponseIdRoute,
  Blue_headerPayerAcompteAncienRoute: Blue_headerPayerAcompteAncienRoute,
  Blue_headerPayerAcompteLegacyRoute: Blue_headerPayerAcompteLegacyRoute,
  Blue_headerReservationConfirmationReservationIdRoute:
    Blue_headerReservationConfirmationReservationIdRoute,
  Blue_headerReservationEstimateResponseIdRoute:
    Blue_headerReservationEstimateResponseIdRoute,
  Blue_headerPayerAcompteIndexRoute: Blue_headerPayerAcompteIndexRoute,
  Blue_headerDevisEstimateResponseIdReserverRoute:
    Blue_headerDevisEstimateResponseIdReserverRoute,
}

const Blue_headerRouteWithChildren = Blue_headerRoute._addFileChildren(
  Blue_headerRouteChildren,
)

interface BookingRouteChildren {
  BookingAssurancesRoute: typeof BookingAssurancesRoute
  BookingCheckoutRoute: typeof BookingCheckoutRoute
  BookingInformationsRoute: typeof BookingInformationsRoute
  BookingPaiementRoute: typeof BookingPaiementRoute
  BookingFlightsResultsRoute: typeof BookingFlightsResultsRoute
  BookingFlightsmanyqueryResultsRoute: typeof BookingFlightsmanyqueryResultsRoute
  BookingVolsMultiResultatsRoute: typeof BookingVolsMultiResultatsRoute
  BookingVolsResultatsRoute: typeof BookingVolsResultatsRoute
}

const BookingRouteChildren: BookingRouteChildren = {
  BookingAssurancesRoute: BookingAssurancesRoute,
  BookingCheckoutRoute: BookingCheckoutRoute,
  BookingInformationsRoute: BookingInformationsRoute,
  BookingPaiementRoute: BookingPaiementRoute,
  BookingFlightsResultsRoute: BookingFlightsResultsRoute,
  BookingFlightsmanyqueryResultsRoute: BookingFlightsmanyqueryResultsRoute,
  BookingVolsMultiResultatsRoute: BookingVolsMultiResultatsRoute,
  BookingVolsResultatsRoute: BookingVolsResultatsRoute,
}

const BookingRouteWithChildren =
  BookingRoute._addFileChildren(BookingRouteChildren)

interface RechercheRouteChildren {
  RechercheIntegrationRoute: typeof RechercheIntegrationRoute
}

const RechercheRouteChildren: RechercheRouteChildren = {
  RechercheIntegrationRoute: RechercheIntegrationRoute,
}

const RechercheRouteWithChildren = RechercheRoute._addFileChildren(
  RechercheRouteChildren,
)

interface ResearchBarRouteChildren {
  ResearchBarEmbedRoute: typeof ResearchBarEmbedRoute
}

const ResearchBarRouteChildren: ResearchBarRouteChildren = {
  ResearchBarEmbedRoute: ResearchBarEmbedRoute,
}

const ResearchBarRouteWithChildren = ResearchBarRoute._addFileChildren(
  ResearchBarRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  Blue_headerRoute: Blue_headerRouteWithChildren,
  BookingRoute: BookingRouteWithChildren,
  RechercheRoute: RechercheRouteWithChildren,
  ResearchBarRoute: ResearchBarRouteWithChildren,
  ConfirmationPaiementStatusRoute: ConfirmationPaiementStatusRoute,
  PaymentConfirmationStatusRoute: PaymentConfirmationStatusRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
